export default function getTypeClass (displayType) {
  return displayType === 'cover'
    ? '--mod-cover'
    : displayType === 'fit'
      ? '--mod-best-fit'
      : '--mod-actual-size'
}



// WEBPACK FOOTER //
// ./src/modules/ModuleImage/utils/getTypeClass.js